[pin]
<div  class="mt-4 w-100 text-center" *ngIf="loading">
    <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
</div>

<div *ngIf="!loading" class="fdm-floatbar">
  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">
    
    <li class="fdm-linked fdm-options-button pointer" (click)="save();mapComp.detailsNav.close();" [matTooltip]="'GENERIC.CLOSE' | translate">
      <fa-icon icon="times"></fa-icon>
    </li>
    <li id="fly-camera" class="fdm-linked fdm-options-button pointer" (click)="mapService.helper.sendCameraTo(annotation)" [matTooltip]="'MAP.FLY_TO' | translate">
      <fa-icon icon="paper-plane"></fa-icon>
    </li>

    <!-- show images -->
    <li id="find-images" class="fdm-linked fdm-options-button pointer" (click)="showImages(true)" matTooltip=" {{ 'MAP.FIND_IMAGES' | translate }}">
      <fa-icon icon="camera"></fa-icon>
    </li>

    <!-- title -->
    <h2>
      <div [class]="'fdm-header-icon fdm-circle-choice float-left fdm-annotation-background-color-white fdm-annotation-color-' + ( annotation.color  || 'blue' )">
      <fa-icon [icon]="annotation.icon || 'map-marker-alt'"></fa-icon>
    </div> {{ annotation.name }} ({{ 'MAP.' + annotation.annotationMode | translate }}) </h2>
  </div>

  <!-- content -->
  <div class="fdm-sidebar-body fdm-sidebar-content fdm-form-field-tight">

    <mat-form-field class="example-full-width">
      <input matInput [placeholder]="'MAP.PIN_NAME' | translate" [(ngModel)]="annotation.name">
    </mat-form-field>

    <div class="fdm-choice-box">
      <label (click)="viewCategories = !viewCategories">{{ 'GENERIC.ACL.CATEGORIES' | translate }} <fa-icon [icon]="viewCategories ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
      <div *ngIf="viewCategories" class="show-choice clearfix">
      <ng-select multiple="true" [(ngModel)]="annotation['categories']" [items]="categoriesSuggestions" [addTag]="addTagFn" (add)="saveCategories()">
        <!-- <ng-option *ngFor="let item of categoriesSuggestions">{{ item['$ngOptionLabel'] | normaliseAcl }}</ng-option> -->
      </ng-select>
      </div>
    </div>

    <div class="fdm-choice-box">
      <label (click)="viewColors = !viewColors">{{ 'MAP.COLOR' | translate }} <fa-icon [icon]="viewColors ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
      <div *ngIf="viewColors" class="show-choice clearfix">
        <div [class]="'fdm-circle-choice float-left fdm-annotation-color-white fdm-annotation-background-color-' + cur"
              *ngFor="let cur of ['red','green','blue','yellow','orange','grey']"
              (click)="annotation.color = cur">
          <fa-icon *ngIf="annotation.color == cur" icon="check"></fa-icon>
        </div>
      </div>
    </div>
      
    <div class="fdm-choice-box">
      <label (click)="viewIcons = !viewIcons">{{ 'GENERIC.ICON' | translate }} <fa-icon [icon]="viewIcons ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
      <div *ngIf="viewIcons" class="show-choice clearfix">
        <div *ngFor="let cur of ['map-marker-alt','flag','exclamation-triangle']"
            [class]="'fdm-circle-choice float-left fdm-annotation-color-grey fdm-annotation-background-color-' + ( annotation.icon ? ( annotation.icon == cur ? 'selected' : 'unselected' ) : cur == 'map-marker-alt' ? 'selected' : 'unselected' ) "
            (click)="annotation.icon = cur">
          <fa-icon [icon]="cur"></fa-icon>
        </div>
      </div>
    </div>

    <div class="fdm-choice-box">
      <label>{{ 'MAP.DESC' | translate }}</label>
      <div class="show-choice clearfix">
          <textarea matInput [(ngModel)]="annotation.desc" [placeholder]="'MAP.DESC' | translate"></textarea>
      </div>
    </div>

    <div class="fdm-choice-box">
      <label>{{ 'MAP.SCREENSHOTS' | translate }}</label>
      <div class="clearfix">

        <div class="show-choice" *ngIf="screenshotName || screenshotByteCharacters">
          <img  *ngIf="screenshotName" style="height:200px;" [vlink]="screenshotName" [model]="annotation">
          <img  *ngIf="screenshotByteCharacters" [src]="screenshotByteCharacters">
          <button mat-raised-button (click)="deleteScreenShot(true);" color="warn">{{
               'GENERIC.DELETE' | translate }}
          </button>
        </div>

        <div class="text-right">
          <span (click)="browsePhotos()" class="mr-2" [matTooltip]="'MAP.ATTACH_PHOTOS' | translate">
            <fa-icon icon="plus"></fa-icon>
          </span>
          <span class="mr-2"  [matTooltip]="'MAP.DELETE_ATTACHED_PHOTOS' | translate" (click)="deleteAttachedPhotos()">
            <fa-icon icon="trash"></fa-icon>
          </span>
        </div>
      </div>
    </div>

    <hr/>
    <button class="float-right pointer mr-1  mb-2" mat-icon-button color="primary" [matTooltip]="'MAP.ADD_POINT' | translate" (click)="openExternalLink()"><mat-icon>add</mat-icon>
    </button>
    <h5 class="primary pt-2 mb-3">{{ 'MAP.LINKS' | translate }}</h5>
    <ul *ngIf="annotation['externalURL']" class="itemList" >
      <li ><a style="cursor:pointer" (click)="openURL(annotation)"><fa-icon icon="link"></fa-icon> {{annotation['externalURL']}}</a></li>
    </ul>
    <hr/>
    <button class="float-right pointer mr-1" mat-icon-button color="primary" [matTooltip]="'MAP.ATTRIBUTES' | translate" (click)="addAttrib()"><mat-icon>add</mat-icon>
    </button>
    <h5 class="primary mt-2 mb-3">{{ 'MAP.ATTRIBUTES' | translate }}</h5>

    <table class="attribTable w-100 mt-3 mb-4">
      <tr *ngFor="let cur of annotation['attributes'];let i = index">
        <td width="40%">
          <input class="w-100 attrib_text" placeholder="{{'MAP.ATTRIBUTES_KEY' | translate }}" [(ngModel)]="cur.key">
        </td>
        <td >
          <input class="w-100 attrib_text" placeholder="{{'MAP.ATTRIBUTES_VALUE' | translate }}" [(ngModel)]="cur.value">
        </td>
        <td width="1%" class="text-right">
          <fa-icon icon="times" (click)="delAttrib(i)"></fa-icon>
        </td>
      </tr>
    </table>

    <div class="text-right">
      <button mat-raised-button color="warn" (click)="del()" class="mr-1">{{ 'GENERIC.DELETE' | translate }}</button>
      <button [disabled]="deletingScreenShot" mat-raised-button color="primary" (click)="save(true)">{{ 'GENERIC.SAVE' | translate }}</button>
    </div>

    <!-- debug -->
    <!-- <textarea style="width:100%;height:270px;font-size:10px;">{{ annotation | json }}</textarea> -->

  </div>
</div>

    <div *ngIf="!loading" class="p-2 noshow">

    <button [matMenuTriggerFor]="pin"  mat-mini-fab class="float-left mt-2 mr-2" color="text-light"
        [ngStyle]="{'color':annotation['color'] || 'blue'}"><fa-icon style="font-size:18px;"  [icon]="annotation.icon || 'map-marker-alt'"></fa-icon></button>
    <input type="text" class="heading_text primary w-90 pt-3"
        [(ngModel)]="annotation.name" />

    <mat-form-field class="full-width mt-2 mb-2"  appearance="fill">
        <textarea matInput [(ngModel)]="annotation.desc" [ngStyle]="attachPhoto || screenshotName || screenshotByteCharacters ? '' : { 'height' : '150px'}"  [placeholder]="'MAP.DESC' | translate"></textarea>
    </mat-form-field>
  <div *ngIf="screenshotName || screenshotByteCharacters">
    <img  *ngIf="screenshotName" style="height:200px;" [vlink]="screenshotName" [model]="annotation">
    <img  *ngIf="screenshotByteCharacters" style="height:200px;" [src]="screenshotByteCharacters">
    <button mat-raised-button (click)="deleteScreenShot(true);" color="warn">{{
      'GENERIC.DELETE' | translate }}
    </button>
  </div>

    <div class="text-right">
      <span (click)="browsePhotos()" class="mr-2" [matTooltip]="'MAP.ATTACH_PHOTOS' | translate">
                    <fa-icon icon="plus"></fa-icon>
                  </span>
      <span class="mr-2"  [matTooltip]="'MAP.DELETE_ATTACHED_PHOTOS' | translate"
            (click)="deleteAttachedPhotos()">
                    <fa-icon icon="trash"></fa-icon>
                  </span>
    </div>
    <hr/>

    <button class="float-right pointer mr-1  mb-2" mat-icon-button color="primary" [matTooltip]="'MAP.ADD_POINT' | translate" (click)="openExternalLink()"><mat-icon>add</mat-icon>
    </button>
    
    <h5 class="primary pt-2 mb-3">{{ 'MAP.LINKS' | translate }}</h5>
    <ul *ngIf="annotation['externalURL']" class="itemList" >
        <li ><a style="cursor:pointer" (click)="openURL(annotation)"><fa-icon icon="link"></fa-icon> {{annotation['externalURL']}}</a></li>
    </ul>
    <hr/>

    <!-- Attributes -->
    <button class="float-right pointer mr-1" mat-icon-button color="primary" [matTooltip]="'MAP.ATTRIBUTES_TOOLTIP' | translate" (click)="addAttrib()"><mat-icon>add</mat-icon>
    </button>
    <h5 class="primary mt-2 mb-3">{{ 'MAP.ATTRIBUTES' | translate }}</h5>

    <table class="attribTable w-100 mt-3 mb-4">
      <tr *ngFor="let cur of annotation['attributes'];let i = index">
        <td width="40%">
          <input class="w-100 attrib_text"  placeholder=" {{'MAP.ATTRIBUTES_KEY' | translate }}" [(ngModel)]="cur.key">
        </td>
        <td >
          <input class="w-100 attrib_text" placeholder="{{'MAP.ATTRIBUTES_VALUE' | translate }}" [(ngModel)]="cur.value">
        </td>
        <td width="1%" class="text-right">
            <fa-icon icon="times" (click)="delAttrib(i)"></fa-icon>
        </td>
      </tr>
    </table>

    <div class="text-right">
        <button mat-raised-button color="warn" (click)="del()" class="mr-1">{{ 'GENERIC.DELETE' | translate }}</button>
        <button [disabled]="deletingScreenShot" mat-raised-button color="primary" (click)="save(true)">{{ 'GENERIC.SAVE' | translate }}</button>
    </div>
</div>

<div  class="mt-4 w-100 text-center" *ngIf="loading">
    <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
</div>

<mat-menu #pin="matMenu" [overlapTrigger]="false">
    <button mat-menu-item [matMenuTriggerFor]="colors">
        {{ 'GENERIC.COLOR' | translate }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="icons">
        {{ 'GENERIC.ICON' | translate }}
    </button>
</mat-menu>

<!-- Icons -->
<mat-menu #icons="matMenu" [overlapTrigger]="false">
    <button mat-menu-item
    *ngFor="let cur of ['map-pin','flag','exclamation-triangle']" (click)="annotation.icon = cur">
        <fa-icon [icon]="cur"></fa-icon>
    </button>
</mat-menu>

<!-- Colors -->
<mat-menu #colors="matMenu" [overlapTrigger]="false">
    <button mat-menu-item *ngFor="let cur of ['red','green','blue','yellow','orange','grey']"
        (click)="annotation.color = cur" [ngStyle]="{'background-color':cur}">
    </button>
</mat-menu>
